import axiosClient from "@/utils/axios-client";
import { BuyerBusinessLicenseResponse } from "@/shared/api/business-license/types";
import { businessLicenseUrl } from "@/shared/api/business-license/url";

export const businessLicenseQueryApi = {
  // 바이어 사업자등록증 조회 — 미등록이면 404가 아니라 200 + null이 온다.
  getBuyerBusinessLicense: async (buyerId: number) => {
    const { data } = await axiosClient.get<BuyerBusinessLicenseResponse | null>(
      businessLicenseUrl.root(buyerId)
    );
    return data;
  },
};
